import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { UrlService } from 'src/app/share/services/url.service';

@Component({
    selector: 'app-citizen-footer-extern',
    templateUrl: './citizen-footer-extern.component.html',
    styleUrls: ['./citizen-footer-extern.component.scss'],
    standalone: false
})
export class CitizenFooterExternComponent implements OnDestroy {
  version_full: string = '';
  version_short: string = '';

  menuitems: any[] = [
    {
      id: 1,
      key: 'legalNotice',
      path: 'extern/imprint',
    },
    {
      id: 2,
      key: 'privacy',
      path: 'extern/privacy',
    },
    {
      id: 3,
      key: 'contactfaq',
      path: 'extern/contact',
    },
  ];

  selectedLanguageObservable: Subscription;

  constructor(private router: Router, private languageService: LanguageService, private urlService: UrlService, private apiService: ApiService) {
    this.getVersion();
    this.selectedLanguageObservable = languageService.get_selectedLanguageObservable.subscribe((lang) => {
      this.menuitems.forEach((x) => {
        if (x.key !== null && x.key !== undefined && x.key.length > 0) {
          x.text = languageService.translate(x.key);
        }
      });
    });
  }

  getVersion() {
    this.apiService.post<any>(RouteKeys.Config.get_version, null).subscribe((response) => {
      this.version_full = response.version;
      var versionSplits = this.version_full.split('-');
      this.version_short = versionSplits[0];
    });
  }

  ngOnDestroy(): void {
    if (this.selectedLanguageObservable) {
      this.selectedLanguageObservable.unsubscribe();
    }
  }

  onMenuItemClick(e) {
    if (e.itemData !== null && e.itemData !== undefined && e.itemData.path !== null && e.itemData.path !== undefined && e.itemData.path.length > 0) {
      this.urlService.naviToPreserveQueryParams(e.itemData.path);
    }
  }
}
